// 사용 예 : $t('filter.exportable')

export default {
  'filter': {
    'priority': 'Featured',
    'release': 'Newest',
    'priceHigh': 'Price (high to low)',
    'priceLow': 'Price (low to high)',
    'category': 'Category',
    'releasedCountry': 'Launched Territories',
    'licensee': 'Licensee',
    'soundLang': 'Sound (Language)',
    'exportable': 'Availability',
    'resetFilter': 'Clear Filter',
    'applyFilter': 'Apply Filter',
    'setFilter': 'Set Filter',
    'closeFilter': 'Close Filter'
  },
  'newLP': {
    'addCart': 'Add to List',
    'alreadyAdded': 'Added to List',
    'category': 'Category',
    'licensee': 'Licensee',
    'sound': 'Sound (Language)',
    'year': 'Launch Year',
    'exportable': 'Availability',
    'canExport': 'Available',
    'cannotExport': 'Non-Available',
    'releasedCountry': 'Launched Territories',
    'maker': 'Licensee',
    'price': 'MSRP',
    'options': 'Option',
    'selectOption': 'Select Option',
    'notExistsOption': 'No Option',
    'noOptions': 'Option is not selected.',
    'release': 'Launched',
    'more': 'Show more',
    'closeMore': 'Close',
    'emptyList': 'No Results'
  },
  'newCartPage': {
    'title': 'My Wish List',
    'description': 'The order is not finalized until confirmed by The Pinkfong Company.\nPlease note that some products may not be available for purchase.',
    'submitOrder': 'Request Quotation',
    'removeAll': 'Delete All',
    'quantity': 'Quantity',
    'request': 'Note / Request',
    'quantityWarningTitle': 'Please enter the quantity correctly.',
    'quantityWarningDescription': 'Some products have an invalid quantity.',
    'quantityWarningField': 'Enter a number greater than 0',
    'quantityWarningFieldMOQ': 'Enter a number greater than MOQ',
    'MOQ': 'MOQ',
    'company': 'Company Name',
    'manager': 'Contact Person',
    'email': 'E-mail',
    'contact': 'Phone No.',
    'orderList': 'Item List',
    'orderProduct': 'Item Name',
    'orderQuantity': 'Quantity',
    'orderRequest': 'Note / Request',
    'agreeMessage': 'I agree to the collection/use of my personal information as described above.',
    'orderTitle': 'Purchase Inquiry Form',
    'orderSubtitle': 'The order is not finalized until confirmed by The Pinkfong Company.\nThe Pinkfong Company will contact you via the email you inserted below.\nPlease note that some products may not be available for purchase.',
    'orderFieldError': 'Please enter in valid format',
    'orderFieldErrorRequired': 'This field is required.',
    'orderFieldErrorEmail': 'Invalid Email',
    'orderCreating': 'Loading a Request Form',
    'orderCreateDone': 'Request Form completed!',
    'orderLoading': 'Requesting Quotation',
    'orderFailed': 'Submission Failed',
    'orderSuccess': 'Your request has been submitted successfully.',
    'removeAllConfirm': 'Do you want to delete all items?',
    'emptyList': 'Your List is empty.',
    'removeAllDone': 'Deleted!',
    'close': 'Cancel',
    'ok': 'OK',
    'saleRegion': 'Distribution Territories'
  },
  'message': {
    'viewSelctedItems': 'View Selected Items',
    'clear': 'Clear',
    'downloadPDF': 'Download PDF',
    'all': 'All',
    'allSelected': 'Select All',
    'allUnSelected': 'Unselect All',
    'selected': 'Select',
    'unSelected': 'Unselect',
    'selectedItem': 'Selected Items',
    'searchResults': 'Search Results',
    'downloading': 'Downloading..'
  },
  'variables': {
    'homeMessage': "<p>Welcome to the Pinkfong Catalog page.</p><p>This catalog provides basic information for B2B cooperation.<br/>Details such as partner price, minimum order quantity (MOQ) can be provided through further communication.<br/>For inquires regarding product and content distribution, please submit a request in the link below.<br/><a target='_blank' href='https://bizhelp.pinkfong.com/hc/en-us'>Pinkfong Business Help Center</a></p>",
    'homeItem': [
      {
        'title': 'Pinkfong In‑house Products',
        'image': 'https://fs.smartstudy.co.kr/catalog/images/main-products.png',
        'link': '/en/pinkfongproducts/all'
      },
      {
        'title': 'Pinkfong Licensed Products',
        'image': 'https://fs.smartstudy.co.kr/catalog/images/main-licensed.png',
        'link': '/en/licensedproducts/all'
      },
      {
        'title': 'Pinkfong Video Content',
        'image': 'https://fs.smartstudy.co.kr/catalog/images/main-video.png',
        'link': '/en/mediacontent/all'
      }
    ],
    'LicensedProducts': 'Licensed Products',
    'PinkfongProducts': 'Pinkfong In-house Products',
    'MediaContent': 'Video Content',
    'licensedproducts': 'Licensed Products',
    'pinkfongproducts': 'Pinkfong In-house Products',
    'mediacontent': 'Video Content',
    'age': 'Age',
    'manufacturer': 'Licensee',
    'category': 'Category',
    'price': 'Price',
    'currencyCode': '$',
    'productDescription': 'Features & Description',
    'productSize': 'Product Size',
    'weight': 'Weight',
    'productMaterial': 'Material',
    'productPackageType': 'Package Type',
    'productBattery': 'Battery',
    'productReleaseDate': 'Release Date',
    'productBarcode': 'Barcode',
    'boxSize': 'Box Size',
    'boxWeight': 'Box Weight',
    'boxQuantity': 'EA/Box ',
    'is_discontinued': 'Discontinued',
    'is_discontinued_true': 'Discontinued',
    'is_discontinued_false': 'On Sale',
    'em_code': 'Electromagnetic Wave Certification Code',
    'contentLanguage': 'Languages',
    'seriesKnitting': 'Amount of Content',
    'contentQuantity': 'Amount of Content',
    'spec': 'Spec',
    'episodes': 'Episodes',
    'onlyEnglishAge': 'Age: ',
    'footerLinks': [
      {
        'name': 'Pinkfong Official Website',
        'link': 'https://www.pinkfong.com/?utm_source=catalog&utm_medium=footer'
      },
      {
        'name': 'Amazon Shop',
        'link': 'https://link.cleve.re/2395/'
      },
      {
        'name': 'Instagram',
        'link': 'https://www.instagram.com/pinkfong.official/'
      },
      {
        'name': 'Facebook',
        'link': 'https://www.facebook.com/pinkfong.official/'
      },
      {
        'name': 'YouTube',
        'link': 'https://www.youtube.com/Pinkfong'
      }
    ],
    'metaList': [
      { name: 'robots', content: 'index,follow' },
      { name: 'description', content: 'Pinkfong Products, Licensed Products, Video Content' },
      { name: 'auth', content: 'Pinkfong' },
      { name: 'keywords', content: 'pinkfong business, pinkfong content, pinkfong video content, pinkfong products' },
      { vmid: 'og:title', property: 'og:title', content: 'Pinkfong Product Catalog' },
      { vmid: 'og:description', property: 'og:description', content: 'Pinkfong Products, Licensed Products, Video Content' },
      { vmid: 'og:image', property: 'og:image', content: 'https://www.pinkfong.com/assets/img/sns.png' }
    ],
    'viewDetail': 'View Details',
    'relatedProducts': 'Related Products'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en.js